<template>
  <section class="controls">
    <div class="controls__start">
      <Key
        id="start"
        :labelUpper="buttonLabel"
        labelledBy="upper"
        emitEvent="toggleGameState"
        :isLight="true"
        v-on="$listeners"
      />
    </div>

    <div class="controls__display">
      <div class="display">
        <div class="display__title" :class="scoreClass">{{ scoreLabel }}</div>
        <div class="display__window">
          <div class="display__number">{{ score > 0 ? score : '' }}</div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { CONTROLS } from '@/data/game.js'

import Key from '@/components/Key.vue'

export default {
  name: 'Controls',
  components: {
    Key,
  },
  props: {
    gameState: {
      type: Number,
      required: true,
    },
    score: {
      type: Number,
      required: true,
    },
  },
  created() {
    this.controls = CONTROLS
  },
  computed: {
    buttonLabel() {
      return this.gameState === 0
        ? this.controls.PLAY_AGAIN
        : this.gameState === 1
        ? this.controls.RESTART_GAME
        : this.controls.START_GAME
    },
    scoreLabel() {
      return this.gameState === 0
        ? this.controls.SCORE_OVER
        : this.controls.SCORE
    },
    scoreClass() {
      return {
        'display__title--over': this.gameState === 0,
      }
    },
  },
}
</script>
